"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeOrgProvidedValue = exports.deserializeValue = exports.deserializeNumber = exports.deserializeFullDateStr = exports.deserializeBoolean = exports.serializeOrgProvidedValue = exports.serializeValue = void 0;
const lodash_1 = __importDefault(require("lodash"));
const error_1 = require("../error");
const typeguards_1 = require("../typeguards");
const { isNil } = lodash_1.default;
const serializeValue = (value) => {
    if (isNil(value)) {
        return null;
    }
    if (value === '') {
        return null;
    }
    return `${value}`;
};
exports.serializeValue = serializeValue;
const serializeOrgProvidedValue = ({ orgProvidedValue, }) => (Object.assign(Object.assign({}, orgProvidedValue), { value: (0, exports.serializeValue)(orgProvidedValue.value) }));
exports.serializeOrgProvidedValue = serializeOrgProvidedValue;
const deserializeBoolean = ({ value, orgProvidedInputId, }) => {
    if (value === 'true') {
        return true;
    }
    if (value === 'false') {
        return false;
    }
    throw new error_1.FinleyError(`Unable to deserialize orgProvidedValue boolean type [value:${value}] for [orgProvidedInputId:${orgProvidedInputId}].`);
};
exports.deserializeBoolean = deserializeBoolean;
const deserializeFullDateStr = ({ value, orgProvidedInputId, }) => {
    (0, error_1.finleyAssert)((0, typeguards_1.isFullDateStr)(value), new error_1.FinleyError(`Unable to deserialize orgProvidedValue fullDateStr type [value:${value}] for [orgProvidedInputId:${orgProvidedInputId}].`));
    return value;
};
exports.deserializeFullDateStr = deserializeFullDateStr;
const deserializeNumber = ({ value, orgProvidedInputId, }) => {
    (0, error_1.finleyAssert)(!lodash_1.default.isNil(value), `Unable to deserialize orgProvidedValue number type [value:${value}] for [orgProvidedInputId:${orgProvidedInputId}].`);
    const number = Number(value);
    (0, error_1.finleyAssert)(Number.isFinite(number), new error_1.FinleyError(`Unable to deserialize orgProvidedValue number type [value:${value}] for [orgProvidedInputId:${orgProvidedInputId}].`));
    return number;
};
exports.deserializeNumber = deserializeNumber;
const deserializeValue = ({ type, value, nullable, orgProvidedInputId, }) => {
    if (nullable && value === null) {
        return value;
    }
    switch (type) {
        case 'boolean':
            return (0, exports.deserializeBoolean)({
                value,
                orgProvidedInputId,
            });
        case 'fullDateStr':
            return (0, exports.deserializeFullDateStr)({
                value,
                orgProvidedInputId,
            });
        case 'number':
            return (0, exports.deserializeNumber)({
                value,
                orgProvidedInputId,
            });
        case 'string':
            return value;
        default:
            return (0, error_1.finleyAssertUnreachable)(type);
    }
};
exports.deserializeValue = deserializeValue;
const deserializeOrgProvidedValue = ({ orgProvidedValue, orgProvidedInput, }) => {
    const { id: orgProvidedInputId, nullable, type } = orgProvidedInput;
    const { value } = orgProvidedValue;
    return Object.assign(Object.assign({}, orgProvidedValue), { value: (0, exports.deserializeValue)({ orgProvidedInputId, value, nullable, type }) });
};
exports.deserializeOrgProvidedValue = deserializeOrgProvidedValue;
//# sourceMappingURL=index.js.map